









import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  components: {
    "add-edit-promotion": () =>
      import("@/components/app/admin/catalogue/promotions/addEditPromotion.vue")
  }
})
export default class AddPromotionView extends Vue {
  public get i18n() {
    return {
      title: this.$t("_action.add_object", {
        object: (this.$t("_.promotion") as string).toLowerCase()
      })
    };
  }
}
